module.exports = () ->
  return {
    restrict: "A",
    scope:
      iterationOrTemplate: "="
      disabled: "&adverseTermsProximityDisabled"
    template: require('./adverse_terms.html')
    controller: ($scope) ->
      $scope.terms = [
        'NEAR3',
        'NEAR5',
        'NEAR10',
        'NEAR15',
        'NEAR20',
        'NEAR25',
        'NEAR30',
        'NEAR50',
        'NEAR99',
        'AND',
      ]

      $scope.setDefaultProximity = () ->
        if not $scope.iterationOrTemplate.proximity
          $scope.iterationOrTemplate.proximity = 'NEAR50'

      $scope.setDefaultProximity()
  }
